<template>
  <main class="main register max-width amateur">
    <article v-if="isCheckingLogin">
      <h1 class="title-medium">Profilo</h1>
      <p>Attendere, verifica in corso</p>
    </article>

    <div v-else>
      <article v-if="user && user.id">
        <h1 class="title-medium">Profilo</h1>
        <user-update-form :user="user" :isCheckingLogin="isCheckingLogin"></user-update-form>
        <p>Se desideri effettuare il log out, <a href="#0" @click.prevent="logout" class="green-link">clicca qui</a>.</p>
      </article>
      <article v-else>
        <p>Questa sezione è riservata agli utenti registrati. Se hai un profilo, effettua l'<router-link to="/login" class="green-link">accesso</router-link>, oppure <router-link to="/signup" class="green-link">registrati come nuovo utente!</router-link></p>
      </article>
    </div>
  </main>
</template>

<script>
import UserUpdateForm from './UserUpdateForm.vue';

export default {
  props: ['user', 'isCheckingLogin'],
  methods: {
    logout: function() {
      this.$eventBus.$emit('user:logout', {goToLogin: true});
    }
  },
  components: {
    'user-update-form': UserUpdateForm
  },
  mounted() {
    document.title = 'Caramba - Modifica Profilo';
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/vue/components/UserEditProfile.vue